export var Role;
(function (Role) {
    /**
     * @deprecated use Manager instead
     */
    Role["Admin"] = "admin";
    Role["Manager"] = "manager";
    Role["Author"] = "author";
    Role["Viewer"] = "viewer";
    /**
     * @deprecated use AuthorRedactedAll instead
     */
    Role["AuthorRedacted"] = "author-redact-on";
    /**
     * @deprecated use ViewerRedactedAll instead
     */
    Role["ViewerRedacted"] = "viewer-redact-on";
    Role["AuthorRedactedSensitive"] = "author-redact-sensitive";
    Role["ViewerRedactedSensitive"] = "viewer-redact-sensitive";
    Role["AuthorRedactedAll"] = "author-redact-all";
    Role["ViewerRedactedAll"] = "viewer-redact-all";
})(Role || (Role = {}));
const roleAdmin = {
    name: Role.Admin,
    accountPermissions: new Set([
        'account/view',
        'account/edit',
        'account/support_access/view',
        'account/support_access/edit',
        'account/billing/view',
        'account/billing/edit',
        'account/team_members/view',
        'account/team_members/edit',
        'account/workspaces/create',
        'account/api_credentials/view',
        'account/api_credentials/edit',
        'account/pipelines/enable',
        'account/journeys/enable',
        'account/cookie_settings/view',
        'account/cookie_settings/edit',
    ]),
    workspacePermissions: new Set([
        'journeys/imports/view',
        'journeys/imports/create',
        'journeys/imports/edit',
        'journeys/imports/delete',
        'journeys/exports/view',
        'journeys/exports/create',
        'journeys/exports/edit',
        'journeys/exports/delete',
        'journeys/message_settings/view',
        'journeys/message_settings/edit',
        'journeys/sending_options/view',
        'journeys/sending_options/edit',
        'journeys/campaigns/view',
        'journeys/campaigns/create',
        'journeys/campaigns/edit',
        'journeys/campaigns/delete',
        'journeys/goals/create',
        'journeys/goals/view',
        'journeys/goals/edit',
        'journeys/goals/delete',
        'journeys/broadcasts/view',
        'journeys/broadcasts/create',
        'journeys/broadcasts/edit',
        'journeys/broadcasts/delete',
        'journeys/newsletters/view',
        'journeys/newsletters/create',
        'journeys/newsletters/edit',
        'journeys/newsletters/delete',
        'journeys/transactional_messages/view',
        'journeys/transactional_messages/create',
        'journeys/transactional_messages/edit',
        'journeys/transactional_messages/delete',
        'journeys/in_app_broadcasts/view',
        'journeys/in_app_broadcasts/create',
        'journeys/in_app_broadcasts/edit',
        'journeys/in_app_broadcasts/delete',
        'journeys/people/view',
        'journeys/people/create',
        'journeys/people/edit',
        'journeys/people/delete',
        'journeys/object_types/view',
        'journeys/object_types/create',
        'journeys/object_types/edit',
        'journeys/object_types/delete',
        'journeys/objects/view',
        'journeys/objects/create',
        'journeys/objects/edit',
        'journeys/objects/delete',
        'journeys/object_relationships/view',
        'journeys/object_relationships/create',
        'journeys/object_relationships/edit',
        'journeys/object_relationships/delete',
        'journeys/forms/view',
        'journeys/forms/create',
        'journeys/forms/edit',
        'journeys/forms/delete',
        'journeys/geofences/view',
        'journeys/geofences/create',
        'journeys/geofences/edit',
        'journeys/geofences/delete',
        'journeys/sql_syncs/view',
        'journeys/sql_syncs/create',
        'journeys/sql_syncs/edit',
        'journeys/sql_syncs/delete',
        'journeys/js_snippets/create',
        'journeys/js_snippets/view',
        'journeys/js_snippets/edit',
        'journeys/js_snippets/delete',
        'journeys/segment_integration/create',
        'journeys/segment_integration/view',
        'journeys/segment_integration/edit',
        'journeys/segment_integration/delete',
        'journeys/messages/send',
        'journeys/messages/edit',
        'journeys/test_events/send',
        'journeys/logs/view',
        'journeys/segments/view',
        'journeys/segments/create',
        'journeys/segments/edit',
        'journeys/segments/delete',
        'journeys/subscription_center/view',
        'journeys/subscription_center/create',
        'journeys/subscription_center/edit',
        'journeys/subscription_center/delete',
        'journeys/subscription_center/enable',
        'journeys/collections/view',
        'journeys/collections/create',
        'journeys/collections/edit',
        'journeys/collections/delete',
        'journeys/snippets/view',
        'journeys/snippets/create',
        'journeys/snippets/edit',
        'journeys/snippets/delete',
        'journeys/layouts/view',
        'journeys/layouts/create',
        'journeys/layouts/edit',
        'journeys/layouts/delete',
        'journeys/email_message_settings/create',
        'journeys/email_message_settings/view',
        'journeys/email_message_settings/edit',
        'journeys/email_message_settings/delete',
        'journeys/slack_message_settings/create',
        'journeys/slack_message_settings/view',
        'journeys/slack_message_settings/edit',
        'journeys/slack_message_settings/delete',
        'journeys/twillio_message_settings/create',
        'journeys/twillio_message_settings/view',
        'journeys/twillio_message_settings/edit',
        'journeys/twillio_message_settings/delete',
        'journeys/push_message_settings/create',
        'journeys/push_message_settings/view',
        'journeys/push_message_settings/edit',
        'journeys/push_message_settings/delete',
        'journeys/in_app_message_settings/create',
        'journeys/in_app_message_settings/view',
        'journeys/in_app_message_settings/edit',
        'journeys/in_app_message_settings/delete',
        'journeys/whatsapp_message_settings/view',
        'journeys/whatsapp_message_settings/edit',
        'journeys/language_settings/create',
        'journeys/language_settings/view',
        'journeys/language_settings/edit',
        'journeys/language_settings/delete',
        'journeys/mParticle/edit',
        'journeys/mParticle/delete',
        'journeys/audiences_integration/view',
        'journeys/audiences_integration/create',
        'journeys/audiences_integration/edit',
        'journeys/audiences_integration/delete',
        'journeys/ad_audience/view',
        'journeys/ad_audience/create',
        'journeys/ad_audience/edit',
        'journeys/ad_audience/delete',
        'journeys/reporting_webhooks/edit',
        'journeys/reporting_webhooks/delete',
        'journeys/assets/view',
        'journeys/assets/create',
        'journeys/assets/edit',
        'journeys/assets/delete',
        'journeys/merge_options/edit',
        'journeys/attribute_data/view',
        'journeys/sensitive_data/view',
        'journeys/goals_revenue/view',
        'journeys/attribute_metadata/edit',
        'journeys/workspace_settings/view',
        'journeys/workspace_settings/edit',
        'journeys/configuration_manager/view',
        'journeys/configuration_manager/create',
        'journeys/configuration_manager/edit',
        'journeys/configuration_manager/delete',
        'journeys/subscriptions/edit',
        'journeys/suppressions/create',
        'journeys/integrations/create',
        'journeys/integrations/edit',
        'journeys/integrations/delete',
        'journeys/integrations/view',
        'journeys/metric_exports/create',
        'journeys/metric_exports/view',
        'parcel/emails/create',
        'parcel/emails/edit',
        'parcel/emails/delete',
        'parcel/emails/view',
        'parcel/components/create',
        'parcel/components/edit',
        'parcel/components/delete',
        'parcel/components/view',
        'parcel/whatsapp/create',
        'parcel/whatsapp/edit',
        'parcel/whatsapp/delete',
        'parcel/whatsapp/view',
        'parcel/sms/create',
        'parcel/push/create',
        'parcel/sms/edit',
        'parcel/push/edit',
        'parcel/sms/delete',
        'parcel/push/delete',
        'parcel/sms/view',
        'parcel/push/view',
        'parcel/in_app/create',
        'parcel/in_app/edit',
        'parcel/in_app/delete',
        'parcel/in_app/view',
        'parcel/previews/send_test',
        'pipelines/sources/view',
        'pipelines/sources/create',
        'pipelines/sources/edit',
        'pipelines/sources/delete',
        'pipelines/destinations/view',
        'pipelines/destinations/create',
        'pipelines/destinations/edit',
        'pipelines/destinations/delete',
        'pipelines/suppressions/view',
        'pipelines/suppressions/create',
        'pipelines/suppressions/delete',
        'pipelines/attribute_data/view',
        'pipelines/sensitive_data/view',
        'journeys/campaigns/execute',
        'journeys/broadcasts/execute',
        'journeys/newsletters/execute',
        'journeys/transactional_messages/execute',
        'journeys/content/publish',
        'journeys/deliveries/view',
        'journeys/deliveries/manage',
        'journeys/deliveries/send',
    ]),
};
const roleAuthorAccountPermissions = new Set([
    'account/support_access/view',
    'account/support_access/edit',
    'account/team_members/view',
    'account/cookie_settings/view',
]);
const roleAuthorRedactAll = {
    name: Role.AuthorRedactedAll,
    accountPermissions: roleAuthorAccountPermissions,
    workspacePermissions: new Set([
        'journeys/message_settings/view',
        'journeys/message_settings/edit',
        'journeys/sending_options/view',
        'journeys/sending_options/edit',
        'journeys/campaigns/view',
        'journeys/campaigns/create',
        'journeys/campaigns/edit',
        'journeys/campaigns/delete',
        'journeys/goals/create',
        'journeys/goals/view',
        'journeys/goals/edit',
        'journeys/goals/delete',
        'journeys/broadcasts/view',
        'journeys/broadcasts/create',
        'journeys/broadcasts/edit',
        'journeys/broadcasts/delete',
        'journeys/newsletters/view',
        'journeys/newsletters/create',
        'journeys/newsletters/edit',
        'journeys/newsletters/delete',
        'journeys/transactional_messages/view',
        'journeys/transactional_messages/create',
        'journeys/transactional_messages/edit',
        'journeys/transactional_messages/delete',
        'journeys/in_app_broadcasts/view',
        'journeys/in_app_broadcasts/create',
        'journeys/in_app_broadcasts/edit',
        'journeys/in_app_broadcasts/delete',
        'journeys/people/view',
        'journeys/object_types/view',
        'journeys/objects/view',
        'journeys/object_relationships/view',
        'journeys/forms/view',
        'journeys/geofences/view',
        'journeys/geofences/create',
        'journeys/geofences/edit',
        'journeys/geofences/delete',
        'journeys/sql_syncs/view',
        'journeys/js_snippets/view',
        'journeys/segment_integration/view',
        'journeys/messages/send',
        'journeys/messages/edit',
        'journeys/test_events/send',
        'journeys/logs/view',
        'journeys/segments/view',
        'journeys/subscription_center/view',
        'journeys/subscription_center/create',
        'journeys/subscription_center/edit',
        'journeys/subscription_center/delete',
        'journeys/collections/view',
        'journeys/snippets/view',
        'journeys/snippets/create',
        'journeys/snippets/edit',
        'journeys/snippets/delete',
        'journeys/layouts/view',
        'journeys/layouts/create',
        'journeys/layouts/edit',
        'journeys/layouts/delete',
        'journeys/email_message_settings/create',
        'journeys/email_message_settings/view',
        'journeys/email_message_settings/edit',
        'journeys/email_message_settings/delete',
        'journeys/slack_message_settings/create',
        'journeys/slack_message_settings/view',
        'journeys/slack_message_settings/edit',
        'journeys/slack_message_settings/delete',
        'journeys/twillio_message_settings/create',
        'journeys/twillio_message_settings/view',
        'journeys/twillio_message_settings/edit',
        'journeys/twillio_message_settings/delete',
        'journeys/push_message_settings/create',
        'journeys/push_message_settings/view',
        'journeys/push_message_settings/edit',
        'journeys/push_message_settings/delete',
        'journeys/in_app_message_settings/create',
        'journeys/in_app_message_settings/view',
        'journeys/in_app_message_settings/edit',
        'journeys/in_app_message_settings/delete',
        'journeys/whatsapp_message_settings/view',
        'journeys/whatsapp_message_settings/edit',
        'journeys/language_settings/create',
        'journeys/language_settings/view',
        'journeys/language_settings/edit',
        'journeys/language_settings/delete',
        'journeys/audiences_integration/view',
        'journeys/ad_audience/view',
        'journeys/assets/view',
        'journeys/assets/create',
        'journeys/assets/edit',
        'journeys/assets/delete',
        'journeys/workspace_settings/view',
        'journeys/metric_exports/create',
        'journeys/metric_exports/view',
        'parcel/emails/create',
        'parcel/emails/edit',
        'parcel/emails/delete',
        'parcel/emails/view',
        'parcel/components/create',
        'parcel/components/edit',
        'parcel/components/delete',
        'parcel/components/view',
        'parcel/whatsapp/create',
        'parcel/whatsapp/edit',
        'parcel/whatsapp/delete',
        'parcel/whatsapp/view',
        'parcel/sms/create',
        'parcel/push/create',
        'parcel/sms/edit',
        'parcel/push/edit',
        'parcel/sms/delete',
        'parcel/push/delete',
        'parcel/sms/view',
        'parcel/push/view',
        'parcel/in_app/create',
        'parcel/in_app/edit',
        'parcel/in_app/delete',
        'parcel/in_app/view',
        'parcel/previews/send_test',
        'pipelines/sources/view',
        'pipelines/destinations/view',
        'pipelines/suppressions/view',
        'journeys/campaigns/execute',
        'journeys/broadcasts/execute',
        'journeys/newsletters/execute',
        'journeys/transactional_messages/execute',
        'journeys/content/publish',
        'journeys/deliveries/view',
        'journeys/deliveries/manage',
        'journeys/deliveries/send',
    ]),
};
const roleAuthorRedacted = {
    name: Role.AuthorRedacted,
    accountPermissions: roleAuthorAccountPermissions,
    workspacePermissions: new Set([...roleAuthorRedactAll.workspacePermissions]),
};
const roleAuthorRedactedSensitive = {
    name: Role.AuthorRedactedSensitive,
    accountPermissions: roleAuthorAccountPermissions,
    workspacePermissions: new Set([
        ...roleAuthorRedactAll.workspacePermissions,
        'journeys/objects/create',
        'journeys/objects/edit',
        'journeys/objects/delete',
        'journeys/object_relationships/create',
        'journeys/object_relationships/edit',
        'journeys/object_relationships/delete',
        'journeys/segments/create',
        'journeys/segments/edit',
        'journeys/segments/delete',
        'journeys/ad_audience/create',
        'journeys/ad_audience/edit',
        'journeys/ad_audience/delete',
        'journeys/attribute_data/view',
        'pipelines/attribute_data/view',
    ]),
};
const roleAuthor = {
    name: Role.Author,
    accountPermissions: roleAuthorAccountPermissions,
    workspacePermissions: new Set([
        ...roleAuthorRedactAll.workspacePermissions,
        'journeys/people/edit',
        'journeys/objects/create',
        'journeys/objects/edit',
        'journeys/objects/delete',
        'journeys/object_relationships/create',
        'journeys/object_relationships/edit',
        'journeys/object_relationships/delete',
        'journeys/segments/create',
        'journeys/segments/edit',
        'journeys/segments/delete',
        'journeys/sensitive_data/view',
        'journeys/goals_revenue/view',
        'pipelines/sensitive_data/view',
        'journeys/ad_audience/create',
        'journeys/ad_audience/edit',
        'journeys/ad_audience/delete',
        'journeys/attribute_data/view',
        'pipelines/attribute_data/view',
    ]),
};
const roleManager = {
    name: Role.Manager,
    accountPermissions: new Set([
        'account/support_access/view',
        'account/support_access/edit',
        'account/team_members/view',
        'account/api_credentials/view',
        'account/api_credentials/edit',
        'account/cookie_settings/view',
    ]),
    workspacePermissions: new Set([
        'journeys/imports/view',
        'journeys/imports/create',
        'journeys/imports/edit',
        'journeys/imports/delete',
        'journeys/exports/view',
        'journeys/exports/create',
        'journeys/exports/edit',
        'journeys/exports/delete',
        'journeys/message_settings/view',
        'journeys/message_settings/edit',
        'journeys/sending_options/view',
        'journeys/sending_options/edit',
        'journeys/campaigns/view',
        'journeys/campaigns/create',
        'journeys/campaigns/edit',
        'journeys/campaigns/delete',
        'journeys/goals/create',
        'journeys/goals/view',
        'journeys/goals/edit',
        'journeys/goals/delete',
        'journeys/broadcasts/view',
        'journeys/broadcasts/create',
        'journeys/broadcasts/edit',
        'journeys/broadcasts/delete',
        'journeys/newsletters/view',
        'journeys/newsletters/create',
        'journeys/newsletters/edit',
        'journeys/newsletters/delete',
        'journeys/transactional_messages/view',
        'journeys/transactional_messages/create',
        'journeys/transactional_messages/edit',
        'journeys/transactional_messages/delete',
        'journeys/in_app_broadcasts/view',
        'journeys/in_app_broadcasts/create',
        'journeys/in_app_broadcasts/edit',
        'journeys/in_app_broadcasts/delete',
        'journeys/people/view',
        'journeys/people/create',
        'journeys/people/edit',
        'journeys/people/delete',
        'journeys/object_types/view',
        'journeys/object_types/create',
        'journeys/object_types/edit',
        'journeys/object_types/delete',
        'journeys/objects/view',
        'journeys/objects/create',
        'journeys/objects/edit',
        'journeys/objects/delete',
        'journeys/object_relationships/view',
        'journeys/object_relationships/create',
        'journeys/object_relationships/edit',
        'journeys/object_relationships/delete',
        'journeys/forms/view',
        'journeys/forms/create',
        'journeys/forms/edit',
        'journeys/forms/delete',
        'journeys/geofences/view',
        'journeys/geofences/create',
        'journeys/geofences/edit',
        'journeys/geofences/delete',
        'journeys/sql_syncs/view',
        'journeys/sql_syncs/create',
        'journeys/sql_syncs/edit',
        'journeys/sql_syncs/delete',
        'journeys/js_snippets/create',
        'journeys/js_snippets/view',
        'journeys/js_snippets/edit',
        'journeys/js_snippets/delete',
        'journeys/segment_integration/create',
        'journeys/segment_integration/view',
        'journeys/segment_integration/edit',
        'journeys/segment_integration/delete',
        'journeys/messages/send',
        'journeys/messages/edit',
        'journeys/test_events/send',
        'journeys/logs/view',
        'journeys/segments/view',
        'journeys/segments/create',
        'journeys/segments/edit',
        'journeys/segments/delete',
        'journeys/subscription_center/view',
        'journeys/subscription_center/create',
        'journeys/subscription_center/edit',
        'journeys/subscription_center/delete',
        'journeys/subscription_center/enable',
        'journeys/collections/view',
        'journeys/collections/create',
        'journeys/collections/edit',
        'journeys/collections/delete',
        'journeys/snippets/view',
        'journeys/snippets/create',
        'journeys/snippets/edit',
        'journeys/snippets/delete',
        'journeys/layouts/view',
        'journeys/layouts/create',
        'journeys/layouts/edit',
        'journeys/layouts/delete',
        'journeys/email_message_settings/create',
        'journeys/email_message_settings/view',
        'journeys/email_message_settings/edit',
        'journeys/email_message_settings/delete',
        'journeys/slack_message_settings/create',
        'journeys/slack_message_settings/view',
        'journeys/slack_message_settings/edit',
        'journeys/slack_message_settings/delete',
        'journeys/twillio_message_settings/create',
        'journeys/twillio_message_settings/view',
        'journeys/twillio_message_settings/edit',
        'journeys/twillio_message_settings/delete',
        'journeys/push_message_settings/create',
        'journeys/push_message_settings/view',
        'journeys/push_message_settings/edit',
        'journeys/push_message_settings/delete',
        'journeys/in_app_message_settings/create',
        'journeys/in_app_message_settings/view',
        'journeys/in_app_message_settings/edit',
        'journeys/in_app_message_settings/delete',
        'journeys/whatsapp_message_settings/view',
        'journeys/whatsapp_message_settings/edit',
        'journeys/language_settings/create',
        'journeys/language_settings/view',
        'journeys/language_settings/edit',
        'journeys/language_settings/delete',
        'journeys/mParticle/edit',
        'journeys/mParticle/delete',
        'journeys/audiences_integration/view',
        'journeys/audiences_integration/create',
        'journeys/audiences_integration/edit',
        'journeys/audiences_integration/delete',
        'journeys/ad_audience/view',
        'journeys/ad_audience/create',
        'journeys/ad_audience/edit',
        'journeys/ad_audience/delete',
        'journeys/reporting_webhooks/edit',
        'journeys/reporting_webhooks/delete',
        'journeys/assets/view',
        'journeys/assets/create',
        'journeys/assets/edit',
        'journeys/assets/delete',
        'journeys/merge_options/edit',
        'journeys/attribute_metadata/edit',
        'journeys/attribute_data/view',
        'journeys/sensitive_data/view',
        'journeys/goals_revenue/view',
        'journeys/workspace_settings/view',
        'journeys/workspace_settings/edit',
        'journeys/configuration_manager/view',
        'journeys/configuration_manager/create',
        'journeys/configuration_manager/edit',
        'journeys/configuration_manager/delete',
        'journeys/subscriptions/edit',
        'journeys/suppressions/create',
        'journeys/integrations/create',
        'journeys/integrations/edit',
        'journeys/integrations/delete',
        'journeys/integrations/view',
        'journeys/metric_exports/create',
        'journeys/metric_exports/view',
        'parcel/emails/create',
        'parcel/emails/edit',
        'parcel/emails/delete',
        'parcel/emails/view',
        'parcel/components/create',
        'parcel/components/edit',
        'parcel/components/delete',
        'parcel/components/view',
        'parcel/whatsapp/create',
        'parcel/whatsapp/edit',
        'parcel/whatsapp/delete',
        'parcel/whatsapp/view',
        'parcel/sms/create',
        'parcel/push/create',
        'parcel/sms/edit',
        'parcel/push/edit',
        'parcel/sms/delete',
        'parcel/push/delete',
        'parcel/sms/view',
        'parcel/push/view',
        'parcel/in_app/create',
        'parcel/in_app/edit',
        'parcel/in_app/delete',
        'parcel/in_app/view',
        'parcel/previews/send_test',
        'pipelines/sources/view',
        'pipelines/sources/create',
        'pipelines/sources/edit',
        'pipelines/sources/delete',
        'pipelines/destinations/view',
        'pipelines/destinations/create',
        'pipelines/destinations/edit',
        'pipelines/destinations/delete',
        'pipelines/suppressions/view',
        'pipelines/suppressions/create',
        'pipelines/suppressions/delete',
        'pipelines/attribute_data/view',
        'pipelines/sensitive_data/view',
        'journeys/campaigns/execute',
        'journeys/broadcasts/execute',
        'journeys/newsletters/execute',
        'journeys/transactional_messages/execute',
        'journeys/content/publish',
        'journeys/deliveries/view',
        'journeys/deliveries/manage',
        'journeys/deliveries/send',
    ]),
};
const roleViewerAccountPermissions = new Set([
    'account/support_access/view',
    'account/team_members/view',
    'account/cookie_settings/view',
]);
const roleViewerRedactAll = {
    name: Role.Viewer,
    accountPermissions: roleViewerAccountPermissions,
    workspacePermissions: new Set([
        'journeys/campaigns/view',
        'journeys/goals/view',
        'journeys/broadcasts/view',
        'journeys/newsletters/view',
        'journeys/transactional_messages/view',
        'journeys/in_app_broadcasts/view',
        'journeys/people/view',
        'journeys/object_types/view',
        'journeys/objects/view',
        'journeys/object_relationships/view',
        'journeys/forms/view',
        'journeys/geofences/view',
        'journeys/sql_syncs/view',
        'journeys/js_snippets/view',
        'journeys/segment_integration/view',
        'journeys/logs/view',
        'journeys/segments/view',
        'journeys/subscription_center/view',
        'journeys/collections/view',
        'journeys/snippets/view',
        'journeys/layouts/view',
        'journeys/email_message_settings/view',
        'journeys/slack_message_settings/view',
        'journeys/twillio_message_settings/view',
        'journeys/push_message_settings/view',
        'journeys/in_app_message_settings/view',
        'journeys/whatsapp_message_settings/view',
        'journeys/language_settings/view',
        'journeys/audiences_integration/view',
        'journeys/ad_audience/view',
        'journeys/assets/view',
        'journeys/workspace_settings/view',
        'journeys/metric_exports/view',
        'journeys/metric_exports/create',
        'parcel/emails/view',
        'parcel/components/view',
        'parcel/whatsapp/view',
        'parcel/sms/view',
        'parcel/push/view',
        'parcel/in_app/view',
        'parcel/previews/send_test',
        'pipelines/sources/view',
        'pipelines/destinations/view',
        'pipelines/suppressions/view',
        'journeys/deliveries/view',
    ]),
};
const roleViewerRedacted = {
    name: Role.ViewerRedacted,
    accountPermissions: roleViewerAccountPermissions,
    workspacePermissions: new Set([...roleViewerRedactAll.workspacePermissions]),
};
const roleViewerRedactSensitive = {
    name: Role.ViewerRedactedSensitive,
    accountPermissions: roleViewerAccountPermissions,
    workspacePermissions: new Set([
        ...roleViewerRedactAll.workspacePermissions,
        'journeys/attribute_data/view',
        'pipelines/attribute_data/view',
    ]),
};
const roleViewer = {
    name: Role.Viewer,
    accountPermissions: roleViewerAccountPermissions,
    workspacePermissions: new Set([
        ...roleViewerRedactAll.workspacePermissions,
        'journeys/attribute_data/view',
        'pipelines/attribute_data/view',
        'journeys/sensitive_data/view',
        'journeys/goals_revenue/view',
        'pipelines/sensitive_data/view',
    ]),
};
export const ROLE_DEFINITIONS = {
    [Role.Admin]: roleAdmin,
    [Role.Manager]: roleManager,
    [Role.Author]: roleAuthor,
    [Role.Viewer]: roleViewer,
    [Role.AuthorRedacted]: roleAuthorRedacted,
    [Role.ViewerRedacted]: roleViewerRedacted,
    [Role.AuthorRedactedSensitive]: roleAuthorRedactedSensitive,
    [Role.ViewerRedactedSensitive]: roleViewerRedactSensitive,
    [Role.AuthorRedactedAll]: roleAuthorRedactAll,
    [Role.ViewerRedactedAll]: roleViewerRedactAll,
};
export const ALL_ROLES = Object.values(Role);
export function roleLabel(role) {
    switch (role) {
        case Role.Admin:
            return 'Account admin';
        case Role.Manager:
            return 'Workspace admin';
        case Role.Author:
        case Role.AuthorRedacted:
        case Role.AuthorRedactedSensitive:
        case Role.AuthorRedactedAll:
            return 'Author';
        case Role.Viewer:
        case Role.ViewerRedacted:
        case Role.ViewerRedactedSensitive:
        case Role.ViewerRedactedAll:
            return 'Viewer';
    }
}
export function accountPermissionsForRole(role) {
    const definition = ROLE_DEFINITIONS[role];
    return definition?.accountPermissions ?? new Set([]);
}
export function workspacePermissionsForRole(role) {
    const definition = ROLE_DEFINITIONS[role];
    return definition?.workspacePermissions ?? new Set([]);
}
// Eventually this will be an attribute returned by the back end rather than
// a large computed object
export function permissionsForRole(role) {
    return new Set([...accountPermissionsForRole(role), ...workspacePermissionsForRole(role)]);
}
//# sourceMappingURL=roles.js.map